<div class="subheader with-padding flgrow">
    <div class="row align-items-center">
        <div class="col-6 col-lg-3">
            <div class="input-group">
                <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearch' | translate }}"
                    [(ngModel)]="searchTerm" autocomplete="off" (keyup.enter)="onSearchFilter()" />
                <div class="input-group-append">
                    <button type="button" class="btn btn-primary" (click)="onSearchFilter()">
                        <em class="fa fa-search"></em>
                    </button>
                </div>
            </div>
        </div>

        <!-- Select Dealer -->
        <div class="col-lg-3 col-md-3 col-sm-6">
            <div *ngIf="dealerList && dealerList.length > 0;">
                <div class="relative flmid">
                    <div class="flgrow">
                        <app-dealer-searchbox-dropdown [dealerList]="dealerList" ngDefaultControl name="dealerDropdown"
                            (onSelectDealer)="onDealerSelected($event)"
                            placeholder="{{ 'lblSelectDealer' | translate }}" [selectedDealer]="dealerId">
                        </app-dealer-searchbox-dropdown>
                    </div>
                </div>
            </div>
        </div>

        <!-- Date Range Picker -->
        <div class="col-lg-3 col-md-3 col-sm-6">
            <div class="date">
              <input bsDaterangepicker name="BookedDate" [bsConfig]="myDateRangePickerOptions" class="form-control" 
              [(ngModel)]="selectedDate" (ngModelChange)="onDateRangeChanged($event)"/>
            </div>
        </div>

        <!-- Clear Button -->
        <button type="submit" (click)="onClearFilter()" class="btn btn-primary btn-md"
            ngbTooltip="{{ 'lblClearFilters' | translate }}" placement="bottom" aria-label="Center Align">
            <em class="far fa-times-circle font16 align-top"></em>
        </button>

        <a class="ml-2 btn btn-outline-primary" href="javascript:void(0);" (click)="onRefresh()"
            aria-label="Center Align">
            <em class="fas fa-sync fa-lg"></em>
        </a>

        <!-- Export Button -->
        <div class="pl-2 d-flex align-items-center flex-sm-row flex-column justify-content-end ml-auto"
            style="margin-right: 10px;">
            <button style="margin-left : 5px;" type="button" (click)="exportAsXLSX()"
                ngbTooltip="{{'lblExportExcel' | translate}}" placement="bottom" aria-label="Center Align">
                <img src="./../../../assets/images/excel.png" height="32" width="32" alt="Excel" />
            </button>
            <button class="ml-2 btn btn-link icon-pdf" type="button" (click)="exportAsPDF()"
                ngbTooltip="{{'lblExportPDF' | translate}}" placement="left" aria-label="Center Align">
                <em class="far fa-file fa-2x"></em>
                <span class="bdg">PDF</span>
            </button>
        </div>
    </div>
</div>

<div class="container prel">
    <div class="row">
        <div class="c12">
            <div class="card mb-3">
                <!-- Body Header -->
                <div class="card-header d-flex justify-content-between" translate>
                    lblWorkOrderStatusReport
                    <div class="font16 fontbold">
                        <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;
                        {{ totalCount }}
                        &nbsp;<span class="font16 fontnormal" translate>lblResults</span>
                    </div>
                </div>
                <!-- Body Content -->
                <div class="table-responsive max-h254" infinite-scroll [infiniteScrollDistance]="scrollDistance"
                    [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollDown()">
                    <table class="tablest1" id="PDFdata">
                        <thead>
                            <tr>
                                <th style="width: 55px" scope="col">#</th>
                                <th scope="col" translate>lblDealerName</th>
                                <th scope="col" sortable="WorkOrder" (sort)="onSort($event)" translate>
                                    lblWoNo </th>
                                <th scope="col" sortable="WorkOrderStatus" (sort)="onSort($event)" translate>
                                    lblWoStatus </th>
                                <th scope="col" sortable="Status" (sort)="onSort($event)" translate>
                                    lblStatus </th>
                                <th scope="col" sortable="CreatedDate" (sort)="onSort($event)" translate>
                                    lblCreatedDate </th>
                                <th scope="col" translate> lblReservationCreated </th>
                                <th scope="col" translate> lblPurchaseOrderCreated </th>
                                <th scope="col" translate> lblSalesOrderCreated </th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="workOrderStatusResponseModel?.length > 0; else load_NotFound_Template">
                                <tr *ngFor="let item of workOrderStatusResponseModel; let i = index">
                                    <td>{{ i + 1 }}</td>
                                    <td>
                                        <ngb-highlight [result]="item.dealerName"></ngb-highlight>
                                    </td>
                                    <td class="text-left">
                                        {{item.workOrder}}
                                    </td>
                                    <td class="text-left">
                                        {{item.workOrderStatus}}
                                    </td>
                                    <td class="text-left">
                                        {{item.status}}
                                    </td>
                                    <td class="text-left">
                                        {{ item.createdDate | date:'short' }}
                                    </td>
                                    <td class="text-center">
                                        <em class="fas fa-check fa-lg" *ngIf="item.reservation === 'Yes'"></em>
                                        <em class="fas fa-times text-danger fa-lg cursordisable"
                                            *ngIf="item.reservation === 'No' "></em>
                                    </td>
                                    <td class="text-center">
                                        <em class="fas fa-check fa-lg" *ngIf="item.purchaseOrder === 'Yes'"></em>
                                        <em class="fas fa-times text-danger fa-lg cursordisable"
                                            *ngIf="item.purchaseOrder === 'No' "></em>
                                    </td>
                                    <td class="text-center">
                                        <em class="fas fa-check fa-lg" *ngIf="item.salesOrder === 'Yes'"></em>
                                        <em class="fas fa-times text-danger fa-lg cursordisable"
                                            *ngIf="item.salesOrder === 'No' "></em>
                                    </td>
                                </tr>
                            </ng-container>
                            <ng-template #load_NotFound_Template>
                                <tr>
                                    <td colspan="8" class="no-record" translate>
                                        lblNoRecordsFound
                                    </td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>